/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { XERC20Lockbox, XERC20LockboxInterface } from "../XERC20Lockbox";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_xerc20",
        type: "address",
      },
      {
        internalType: "address",
        name: "_erc20",
        type: "address",
      },
      {
        internalType: "bool",
        name: "_isNative",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "IXERC20Lockbox_Native",
    type: "error",
  },
  {
    inputs: [],
    name: "IXERC20Lockbox_NotNative",
    type: "error",
  },
  {
    inputs: [],
    name: "IXERC20Lockbox_WithdrawFailed",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "abc",
        type: "address",
      },
    ],
    name: "ABC",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "Deposit",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "Withdraw",
    type: "event",
  },
  {
    inputs: [],
    name: "ERC20",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "IS_NATIVE",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "XERC20",
    outputs: [
      {
        internalType: "contract IXERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
  {
    inputs: [],
    name: "depositNative",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "deposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "depositTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_to",
        type: "address",
      },
    ],
    name: "depositNativeTo",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "withdrawTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type XERC20LockboxConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: XERC20LockboxConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class XERC20Lockbox__factory extends ContractFactory {
  constructor(...args: XERC20LockboxConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "XERC20Lockbox";
  }

  deploy(
    _xerc20: string,
    _erc20: string,
    _isNative: boolean,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<XERC20Lockbox> {
    return super.deploy(
      _xerc20,
      _erc20,
      _isNative,
      overrides || {}
    ) as Promise<XERC20Lockbox>;
  }
  getDeployTransaction(
    _xerc20: string,
    _erc20: string,
    _isNative: boolean,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _xerc20,
      _erc20,
      _isNative,
      overrides || {}
    );
  }
  attach(address: string): XERC20Lockbox {
    return super.attach(address) as XERC20Lockbox;
  }
  connect(signer: Signer): XERC20Lockbox__factory {
    return super.connect(signer) as XERC20Lockbox__factory;
  }
  static readonly contractName: "XERC20Lockbox";
  public readonly contractName: "XERC20Lockbox";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): XERC20LockboxInterface {
    return new utils.Interface(_abi) as XERC20LockboxInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): XERC20Lockbox {
    return new Contract(address, _abi, signerOrProvider) as XERC20Lockbox;
  }
}
